<template>
  <div class="top-box u-width-100">
    <nav class="top-nav u-flex u-col-center u-row-between font-14">
      <div class="top-nav-left">
        <span>中文 | English</span>
        <span class="cursor" @click="goIndex">首页</span>
        <span>帮助热线：010-82895385</span>
        <a href="http://www.aitrans.org.cn/" target="_blank">爱译社</a>
      </div>
      <div class="top-nav-right">
        <template v-if="showRight">
          <span class="hover-span cursor" @click="login">登录</span>
          <span class="hover-span cursor" @click="register">注册</span>
        </template>
        <template v-if="showUser">
          <div class="login-box" v-if="token && userInfo_">
            <span class="cursor hover-span" @click="click(1)">退出登录</span>
            <span class="cursor hover-span" @click="click(2)">用户中心</span>
            <span class="hover-span2 cursor" v-if="userInfo_ && userInfo_.username">{{ userInfo_.username
            }}，欢迎您！</span>
            <span class="hover-span2 cursor" v-else-if="userInfo && userInfo.email">{{ userInfo.email
            }}，欢迎您！</span>
            <span class="hover-span2 cursor" v-else-if="userInfo_">{{ userInfo_.mobilephone | phoneFilter()
            }}，欢迎您！</span>
          </div>
          <div class="login-box" v-else>
            <span class="cursor hover-span" @click="login">登录</span>
            <span class="cursor hover-span" @click="register">注册</span>
          </div>
        </template>
        <!-- <a class="hover-span cursor" href="http://global.aitrans.org.cn/old/forwardAction/forward_toHelp.do">帮助中心</a> -->
      </div>
    </nav>
  </div>
</template>
  
<script>
export default {
  name: 'topNav',
  props: {
    showRight: {
      type: Boolean,
      default: false
    },
    showUser: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => { JSON.parse(localStorage.getItem('userinfo')) }
    }
  },
  data() {
    return {
      // userInfo: JSON.parse(localStorage.getItem('userinfo')),
      token: localStorage.getItem('token'),
      userInfo_: JSON.parse(localStorage.getItem('userinfo'))
    }
  },
  created() {
      console.log(this.token)
  },
  methods: {
    goIndex() {
      this.$router.push({
        path: "/",
      });
    },
    login() {
      this.$emit('login')
    },
    register() {
      this.$emit('register')
    },
    click(type) {
      if (type == 1) {
        localStorage.removeItem('token')
        localStorage.removeItem('userinfo')
        let proxy = this.$route.path
        this.$store.commit('setPath', proxy ? proxy : '/')
        localStorage.setItem('lastVisitPath', proxy ? proxy : '/');
        console.log(111, proxy, this.$store.state.lastVisitPath)
        window.location.href = `http://global.aitrans.org.cn/old/ClientUser/clientUserAction_exit.do`
        // window.location.href = `http://y406x20468.qicp.vip/old/ClientUser/clientUserAction_exit.do`
      } else {
        console.log(this.userInfo)
        // window.location.href =  `https://global.aitrans.org.cn/old/cilentCustomer/findUI.do`
      }
    }
  }
}
</script>
  
<style scoped lang="scss">
.top-nav {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  .top-nav-left {

    span,
    a {
      margin-left: 50px;
      color: #fff;
    }

    span:first-child {
      margin-left: 0;
    }
  }

  .top-nav-right {
    display: flex;
  }
}

.top-box {
  height: 35px;
  line-height: 35px;
  background: #3a3f51;
  color: #fff;
  position: fixed;
  top: 0;
  z-index: 999;
}

.logo {
  width: 240px;
  height: auto;
  cursor: pointer;
  margin-left: 45px;
  margin-bottom: 15px;
}

.top-menu {
  width: 1200px;
  padding: 56px 0 10px;
  margin: 0 auto;
}

.menu-box {
  height: 40px;
  margin-bottom: 0px;
  width: 1200px;
  background: #08A5E0;
  border-radius: 5px;
  color: #fff;
  padding: 0 20px;
}

::v-deep .ivu-menu-horizontal.ivu-menu-light:after {
  background: #08A5E0 !important;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  color: #fff;
}

::v-deep .ivu-menu-light {
  background-color: #08A5E0;
}

::v-deep .ivu-menu,
.ivu-menu-item {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}

::v-deep .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item {
  font-size: 14px !important;
  text-align: center;
  height: 40px;
  line-height: 40px;
  padding: 0;
  color: #fff;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  background-color: #07BB07;
  color: #fff;
  border-bottom: none;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover {
  background-color: #07BB07;
  color: #fff;
}

::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-drop-list .ivu-menu-item:hover {
  background-color: #08A5E0;
}

::v-deep .ivu-select-dropdown {
  padding: 0;
  margin: 3px 0;
  color: #fff;
  background: #4169E1;
}

.hover-span,
.hover-span2 {
  color: #fff3e3;
  margin: 0 20px;
}

.hover-span:hover {
  color: #77ff00;
}

.hover-span2:hover {
  color: #777777;
}
</style>
  